import axios from 'axios';
import { useMutation } from 'react-query';

export default function useSearchIdCards() {
  const {
    mutate,
    isLoading,
    data: idCardsResponse,
    error,
  } = useMutation(async (searchPayload) => {
    const response = await axios.post('/idcards/search', searchPayload);
    return response;
  });

  const searchIdCards = (payload) => {
    mutate(payload);
  };

  return {
    searchIdCards,
    idCardsResponse,
    isLoading,
    error,
  };
}
